module.exports = __webpack_public_path__ + "static/media/brief_logo.0ab5c6ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/brief_logo.jpg
// module id = 1739
// module chunks = 0 1